import React, { useState, useEffect, useContext } from 'react';
import Toaster from 'toastr';
import { Context } from './app';
import Loading from '../components/Loading';
import CommonUtils from '../util/CommonUtils';
import API from '../service/SiteKickAPIService';

function SubmitACase(props) {

    let cancel = props.cancel;
    let appContex = useContext(Context);
    let user = appContex.user;

    const [customer, setCustomer] = useState({});
    const [relatedlinks, setRelatedLinks] = useState("");
    const [description, setDescription] = useState("");
    const [subject, setSubject] = useState("");
    const [sf_contact_id, setSfContactId] = useState("");
    const [loading, setLoading] = useState(true);
    const [orderId, setOrderId] = useState(-1);

    useEffect(() => {
        fetchSFCustomer();
        getOrderId(user.site_selected.order_number).then((v) => setOrderId(v));
    }, [])

    useEffect(() => {
        fetchSFContact();
    }, [customer])

    const handleInputChange = (e) => {
        e.preventDefault();
        const target = e.target;

        switch (target.name) {
            case "subject":
                setSubject(target.value);
                break;
            case "description":
                setDescription(target.value);
                break;
            case "relatedlinks":
                setRelatedLinks(target.value);
                break;
            default:
                break;
        }
    }

    let getOrderId = (orderNr) => {
        return new Promise((resolve, reject) => {
            let data = {
                criteria: {
                    attributes: ['OrderNumber', 'id'],
                    filters: [{ field: "OrderNumber", value: "%25" + orderNr, operator: "like" }],
                    order_by: [{ field: "OrderNumber", order: "asc" }]
                }
            };
            CommonUtils.ajax(
                {
                    url: 'https://www.sitesupt.com/sf/order/search',
                    type: 'POST',
                    headers: {
                        "user_login": user.user_login,
                        "user_token": user.user_token
                    },
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    data: JSON.stringify(data)
                }
            ).then(
                result => {
                    let orderId = -1;
                    if (result.status && result.status.code === 200 && result.data) {
                        for (let c of result.data.records) {
                            if (parseInt(c.OrderNumber === parseInt(orderNr))) {
                                orderId = c.Id;
                                break;
                            }
                        }
                    }
                    console.log(orderId);
                    resolve(orderId);
                });
        });
    }

    let submitCase = () => {
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            form_input: {
                AccountId: customer && customer.sf_acc_id,
                Subject: user.site_selected.site_name + " - " + subject,
                Description: description,
                SiteSupt_Information__c: relatedlinks,
                ContactId: sf_contact_id
            }
        }

        if (orderId !== -1) {
            data.form_input.Order__c = this.state.orderId;
        } else {
            Toaster.info('Order Number associated with site is invalid. However, proceeding with case creation.');
        }

        CommonUtils.ajax(
            {
                url: 'https://www.sitesupt.com/sf/case/create',
                type: 'POST',
                headers: {
                    "user_login": user.user_login,
                    "user_token": user.user_token
                },
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if ((res && res.status && res.status.code === 200) || (res && res.status && res.status.code === 201)) {
                    Toaster.success("Case created successfully");
                    setRelatedLinks("");
                    setSubject("");
                    setDescription("");
                } else {
                    Toaster.success("Error occured! Try again");
                    setRelatedLinks("");
                    setSubject("");
                    setDescription("");
                }
            }
        )
    }

    const fetchSFCustomer = () => {
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            criteria: {
                from: 0,
                size: 1000,
                customer_id: user.site_selected.customer_id
            },
            attributes: "customer_id,customer_busname,sf_acc_id,sf_acc_name"
        }
        CommonUtils.ajax(
            {
                url: API.COMMON_TABLE_OPERATIONS.CUSTOMER.FETCH,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res.status && res.status.code === 200) {
                    let result = res.data.records[0];
                    setCustomer(result);
                } else {
                    setCustomer({});
                }
            }
        )
    }

    // using this api for fetching the user_login of the site_superintendent
    const fetchSFContact = () => {
        var data = {
            user_login: user.user_login,
            user_token: user.user_token,
            criteria: {
                from: 0,
                size: 1000,
                customer_id: user.site_selected.customer_id
            }
        }

        CommonUtils.ajax(
            {
                url: API.COMMON_TABLE_OPERATIONS.USER.FETCH,
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res && res.status && res.status.code === 200) {
                    let records = res.data.records;
                    let admin_users = records.filter((S, i) => S.record.user_name === user.site_selected.site_superintendent);
                    let user_login = admin_users.length > 0 ? admin_users[0].user_login : ""
                    // setUser_login(user_login);
                    setSfContactId("");
                    if (user_login) {
                        let data = {
                            user_login: user.user_login,
                            user_token: user.user_token,
                            criteria: {
                                attributes: ["name", "id", "email"],
                                filters: [{ "field": "email", "operator": "=", "value": user_login }],
                                order_by: [{ "field": "name", "order": "asc" }],
                                limit: 1,
                                offset: 0
                            }
                        };

                        CommonUtils.ajax(
                            {
                                url: 'https://www.sitesupt.com/sf/contact/search',
                                type: 'POST',
                                headers: {
                                    "user_login": user.user_login,
                                    "user_token": user.user_token
                                },
                                contentType: "application/json; charset=utf-8",
                                dataType: "json",
                                data: JSON.stringify(data)
                            }).then(
                                (result) => {
                                    if (result.status && (result.status.code === 201 || result.status.code === 200) && result.data) {
                                        setSfContactId(result.data.records && result.data.records.length > 0 ? result.data.records[0].Id : "");
                                        setLoading(false);
                                    } else if (result.status && result.status.code === 201 && result.status.message === "TOKEN_EXPIRED") {
                                        Toaster.error("Error occurred ... ")
                                    } else {
                                        this.setState({ loading: false })
                                    }
                                })
                    } else {
                        setLoading(false);
                    }
                }
            })
    }

    var SaveBtnDisable = subject.trim().length === 0 && description.trim().length === 0 && relatedlinks.length === 0;
    return (
        <React.Fragment>
            {!loading ? <div className="modal-content">
                <div className="modal-body pt-0">
                    <form id="case_form" target="case_form" name="case_form">
                        <div className="row pb-2">
                            <div className="col-md-12">
                                <label className="text-primary" htmlFor="name">Name</label>
                                <input className="form-control" style={{ width: '100%' }} type="text" id="name" readOnly name="name" size="20" defaultValue={user.user_login} />
                            </div>
                        </div>
                        <div className="row pb-2">
                            <div className="col-md-12">
                                <label className="text-primary" htmlFor="account">Account</label>
                                <input className="form-control" style={{ width: '100%' }} id="account" readOnly name="account" size="20" type="text" defaultValue={customer.sf_acc_name && customer.sf_acc_name} />
                            </div>
                        </div>
                        <div className="row pb-2">
                            <div className="col-md-12">
                                <label className="text-primary" htmlFor="project">Project</label>
                                <input className="form-control" style={{ width: '100%' }} id="project" readOnly name="project" size="20" type="text" defaultValue={customer.customer_busname && customer.customer_busname + " - " + user.site_selected.site_name + ", " + user.site_selected.site_city} />
                            </div>
                        </div>
                        <div className="row pb-2">
                            <div className="col-md-12">
                                <label className="text-primary" htmlFor="subject">Subject</label>
                                <input className="form-control" style={{ width: '100%' }} id="subject" name="subject" size="20" type="text" autoComplete="off" value={subject} onChange={handleInputChange} required="" />
                            </div>
                        </div>
                        <div className="row pb-2">
                            <div className="col-md-12">
                                <label className="text-primary" htmlFor="description">Description</label>
                                <textarea className="form-control" style={{ width: '100%' }} id="description" name="description" autoComplete="off" value={description} onChange={handleInputChange} required="" />
                            </div>
                        </div>
                        <div className="row pb-2">
                            <div className="col-md-12">
                                <label className="text-primary" htmlFor="relatedlinks">Related Links:</label>
                                <input className="form-control" style={{ width: '100%' }} id="relatedlinks" name="relatedlinks" autoComplete="off" value={relatedlinks} onChange={handleInputChange} required="" />
                            </div>
                        </div>
                    </form>
                </div>
                <div className="modal-footer">
                    <button
                        className="btn btn-secondary mt-2"
                        type="button"
                        data-dismiss="modal"
                        onClick={cancel}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-sm btn-primary pull-right mt-2"
                        type="button"
                        data-dismiss="modal"
                        disabled={SaveBtnDisable}
                        onClick={submitCase}
                    >
                        Save Case
                    </button>
                </div>
            </div> : <center> <Loading> Loading ... </Loading> </center>
            }
        </React.Fragment>
    );
}

export default SubmitACase;